// From @rothoblaas/design-system (ui-components-library, src/hooks), unchanged.
import { useEffect, useState } from "react";

const MOBILE_MEDIA_QUERY = "(max-width: 600px) and (pointer: coarse)";

function getIsMobileDevice() {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
    return false;
  }

  return window.matchMedia(MOBILE_MEDIA_QUERY).matches;
}

/** True on small-screen touch devices (phones), based on viewport width and pointer precision. */
export function useIsMobileDevice() {
  const [isMobile, setIsMobile] = useState(getIsMobileDevice);

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
      return;
    }

    const query = window.matchMedia(MOBILE_MEDIA_QUERY);
    const onChange = () => setIsMobile(query.matches);

    onChange();
    query.addEventListener("change", onChange);
    return () => query.removeEventListener("change", onChange);
  }, []);

  return isMobile;
}
